/**
 * Turn Google Calendar Phase 2b — Badge d'état de synchro Google Calendar pour un RDV.
 *
 * Se base sur `rdv.google_sync_status` :
 *  - "synced"        → badge vert  "📅 Synchronisé"
 *  - "error"         → badge rouge "⚠️ Erreur sync" (tooltip explicatif)
 *  - "not_connected" | vide | autres → rien (n'affiche RIEN pour ne pas
 *    polluer l'UI des users sans Google Calendar).
 */
import { Calendar as CalendarIcon, AlertTriangle } from "lucide-react";

export default function RdvSyncBadge({ status, size = "sm", className = "" }) {
  if (!status || status === "not_connected" || status === "pending") return null;

  const isSmall = size === "sm";
  const base = "inline-flex items-center gap-1 rounded-md border font-medium";
  const sizing = isSmall ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs";

  if (status === "synced") {
    return (
      <span
        className={`${base} ${sizing} badge-success ${className}`}
        data-testid="rdv-sync-badge-synced"
        title="Événement présent dans ton Google Calendar"
      >
        <CalendarIcon className="h-3 w-3" /> Synchronisé
      </span>
    );
  }

  if (status === "error") {
    return (
      <span
        className={`${base} ${sizing} badge-error ${className}`}
        data-testid="rdv-sync-badge-error"
        title="L'événement n'a pas pu être créé dans Google Calendar, réessaie plus tard"
      >
        <AlertTriangle className="h-3 w-3" /> Erreur sync
      </span>
    );
  }

  return null;
}
